// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    height: 100%;
    margin: 0;
    padding: 0;
    overflow-y: auto; /* Allow scrolling when modal is not open */
}


.login-menu-modal-overlay {
    position: fixed;
    inset: 0;  /* Cover the entire screen */
    padding: env(safe-area-inset-top) env(safe-area-inset-right) 
             env(safe-area-inset-bottom) env(safe-area-inset-left);
    background-color: rgba(0, 0, 0, 0.185);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    opacity: 0;
    overflow: hidden;
    transition: opacity 0.3s ease; /* Smooth transition */
}

.login-menu-modal {
    display: flex;
    background-color: rgb(255, 255, 255);
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 400px;
    padding: 50px;
    border-radius: 20px;
    box-sizing: border-box;
}

.login-input-container{
    width: 100%;
}

.login-input-container input {
    padding: 16px;
    margin: 0px;
    background-color: #F6F7F9;
    outline: none;
    border: none;
    border-radius: 8px;
    box-sizing: border-box;
}

.login-input-container button {
    background-color: #6294aa;
    padding: 10px 20px;
    color: #F6F7F9;
    border: none;
    border-radius: 6px;
    transition: background-color 0.3s ease;
    font-size: 16px;
    transition: all 0.3s ease;
    cursor: pointer;
    margin-top: 10px;
    float: right;
}

.login-button {
    width: 100%;
    height: 45px;
    float: none;
    margin-top: 20px!important;
}

.login-button:hover {
  background-color: #7bafc5;
}

.login-close-button {
    position: relative;
    background-color: rgba(255, 0, 0, 0)!important;
    color: #333!important;
    top: 0px;
    right: 0px;
    padding: 20px;
    background: none;
    border: none;
    font-size: 35px!important;
    font-weight: lighter;
    cursor: pointer;
    transform: translate(45px, -55px);
    transition: 0.3s;
}

.login-close-button:hover {
    color: #666!important;
}

.fade-in {
    opacity: 1;
}

.fade-out {
    opacity: 0;
    pointer-events: none; /* Prevent clicks during fade-out */
}

.error-message {
  color: red;
  margin-top: 10px;
}

.success-message {
  color: green;
  margin-top: 10px;
}

.toggle-mode {
  margin-top: 20px;
  text-align: left;
}

.toggle-mode .toggle-button {
  background: none;
  color: #6294AA;
  border: none;
  cursor: pointer;
  font-weight: bold;
  text-decoration: underline;
  font-size: 14px;
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background-color: #f7f8fa;
  justify-content: center;
  border-radius: 8px;
}

.password-input-wrapper input {
  flex: 1 1;
}

.toggle-password-button {
  background-color: #36518600!important;
  padding: 10px!important;
  margin-top: 0!important;
}

.toggle-password-button svg {
  width: 20px;
  height: 20px;
  color: #555;
}

.logout-button {
  background-color: #C94C4C;
  padding: 10px 20px;
  color: #F6F7F9;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/LoginMenuModal.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,SAAS;IACT,UAAU;IACV,gBAAgB,EAAE,2CAA2C;AACjE;;;AAGA;IACI,eAAe;IACf,QAAQ,GAAG,4BAA4B;IACvC;kEAC8D;IAC9D,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,6BAA6B,EAAE,sBAAsB;AACzD;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,0BAA0B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,8CAA8C;IAC9C,qBAAqB;IACrB,QAAQ;IACR,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,oBAAoB,EAAE,mCAAmC;AAC7D;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["html, body {\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    overflow-y: auto; /* Allow scrolling when modal is not open */\n}\n\n\n.login-menu-modal-overlay {\n    position: fixed;\n    inset: 0;  /* Cover the entire screen */\n    padding: env(safe-area-inset-top) env(safe-area-inset-right) \n             env(safe-area-inset-bottom) env(safe-area-inset-left);\n    background-color: rgba(0, 0, 0, 0.185);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    opacity: 0;\n    overflow: hidden;\n    transition: opacity 0.3s ease; /* Smooth transition */\n}\n\n.login-menu-modal {\n    display: flex;\n    background-color: rgb(255, 255, 255);\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    max-width: 400px;\n    padding: 50px;\n    border-radius: 20px;\n    box-sizing: border-box;\n}\n\n.login-input-container{\n    width: 100%;\n}\n\n.login-input-container input {\n    padding: 16px;\n    margin: 0px;\n    background-color: #F6F7F9;\n    outline: none;\n    border: none;\n    border-radius: 8px;\n    box-sizing: border-box;\n}\n\n.login-input-container button {\n    background-color: #6294aa;\n    padding: 10px 20px;\n    color: #F6F7F9;\n    border: none;\n    border-radius: 6px;\n    transition: background-color 0.3s ease;\n    font-size: 16px;\n    transition: all 0.3s ease;\n    cursor: pointer;\n    margin-top: 10px;\n    float: right;\n}\n\n.login-button {\n    width: 100%;\n    height: 45px;\n    float: none;\n    margin-top: 20px!important;\n}\n\n.login-button:hover {\n  background-color: #7bafc5;\n}\n\n.login-close-button {\n    position: relative;\n    background-color: rgba(255, 0, 0, 0)!important;\n    color: #333!important;\n    top: 0px;\n    right: 0px;\n    padding: 20px;\n    background: none;\n    border: none;\n    font-size: 35px!important;\n    font-weight: lighter;\n    cursor: pointer;\n    transform: translate(45px, -55px);\n    transition: 0.3s;\n}\n\n.login-close-button:hover {\n    color: #666!important;\n}\n\n.fade-in {\n    opacity: 1;\n}\n\n.fade-out {\n    opacity: 0;\n    pointer-events: none; /* Prevent clicks during fade-out */\n}\n\n.error-message {\n  color: red;\n  margin-top: 10px;\n}\n\n.success-message {\n  color: green;\n  margin-top: 10px;\n}\n\n.toggle-mode {\n  margin-top: 20px;\n  text-align: left;\n}\n\n.toggle-mode .toggle-button {\n  background: none;\n  color: #6294AA;\n  border: none;\n  cursor: pointer;\n  font-weight: bold;\n  text-decoration: underline;\n  font-size: 14px;\n}\n\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background-color: #f7f8fa;\n  justify-content: center;\n  border-radius: 8px;\n}\n\n.password-input-wrapper input {\n  flex: 1;\n}\n\n.toggle-password-button {\n  background-color: #36518600!important;\n  padding: 10px!important;\n  margin-top: 0!important;\n}\n\n.toggle-password-button svg {\n  width: 20px;\n  height: 20px;\n  color: #555;\n}\n\n.logout-button {\n  background-color: #C94C4C;\n  padding: 10px 20px;\n  color: #F6F7F9;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
